/* ============================================================
   PRAWS · Bundle BYO controller
   - Catalogo + tier preview
   - Image swap when changing color/size selector
   - Opens existing cart drawer on add
   ============================================================ */

(function () {
  'use strict';

  const formatMoneyCLP = (cents) => {
    // Shopify Ajax API returns prices in cents (×100) for CLP. Divide by 100 for display.
    const amount = Math.round((Number(cents) || 0) / 100);
    return '$' + amount.toLocaleString('es-CL').replace(/,/g, '.');
  };

  const variantFeaturedImageUrl = (variant) => {
    if (!variant) return null;
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (variant.image && variant.image.src) return variant.image.src;
    if (typeof variant.featured_image === 'string') return variant.featured_image;
    return null;
  };

  const ensureProtocol = (url) => {
    if (!url) return url;
    if (url.startsWith('//')) return window.location.protocol + url;
    return url;
  };

  async function refreshAndOpenSlideCart() {
    try {
      if (typeof window.SLIDECART_UPDATE === 'function') {
        const r = window.SLIDECART_UPDATE();
        if (r && typeof r.then === 'function') await r;
      }
    } catch (e) { console.warn('SLIDECART_UPDATE failed:', e); }
    try {
      if (typeof window.SLIDECART_OPEN === 'function') {
        window.SLIDECART_OPEN();
        return true;
      }
    } catch (e) { console.warn('SLIDECART_OPEN failed:', e); }
    return false;
  }

  document.querySelectorAll('[data-byo-bundle]').forEach((root) => {
    const config = JSON.parse(root.querySelector('[data-byo-config]')?.textContent || '{}');
    const tiers = (config.tiers || []).sort((a, b) => a.min_items - b.min_items);
    const minItems = config.min_items || 2;
    const maxItems = config.max_items || 99;

    const cartList = root.querySelector('[data-byo-cart-list]');
    const cartEmpty = root.querySelector('[data-byo-cart-empty]');
    const countEl = root.querySelector('[data-byo-count]');
    const countPluralEl = root.querySelector('[data-byo-count-plural]');
    const subtotalEl = root.querySelector('[data-byo-subtotal]');
    const discountRow = root.querySelector('[data-byo-discount-row]');
    const discountLabelEl = root.querySelector('[data-byo-discount-label]');
    const discountAmountEl = root.querySelector('[data-byo-discount-amount]');
    const totalEl = root.querySelector('[data-byo-total]');
    const ctaBtn = root.querySelector('[data-byo-checkout]');
    const progressFill = root.querySelector('[data-byo-progress-fill]');
    const progressMsg = root.querySelector('[data-byo-progress-msg]');
    const tierChips = root.querySelectorAll('.byo__tier-chip');
    const progressTiers = root.querySelectorAll('[data-progress-tier-min]');
    const sidebarEl = root.querySelector('[data-byo-sidebar]');
    const sidebarToggle = root.querySelector('[data-byo-sidebar-toggle]');
    const handleCountEl = root.querySelector('[data-byo-handle-count]');
    const handleTotalEl = root.querySelector('[data-byo-handle-total]');

    const state = { items: [] };

    const resolveVariantForCard = (card) => {
      const variantsAttr = card.dataset.productVariants;
      if (!variantsAttr) return null;
      let variants;
      try { variants = JSON.parse(variantsAttr); } catch { return null; }
      const optionSelects = card.querySelectorAll('[data-byo-option-name]');
      if (optionSelects.length === 0) return variants[0];
      const selectedValues = {};
      optionSelects.forEach((sel) => { selectedValues[sel.dataset.byoOptionName] = sel.value; });
      const options = JSON.parse(card.dataset.productOptions || '[]');
      const matched = variants.find((v) => {
        return v.options.every((optVal, idx) => {
          const optName = options[idx] && options[idx].name;
          return selectedValues[optName] === optVal;
        });
      });
      return matched || variants[0];
    };

    const updateCardImage = (card, variant) => {
      const imgEl = card.querySelector('.byo__product-image img');
      if (!imgEl || !variant) return;
      const newUrl = variantFeaturedImageUrl(variant);
      if (!newUrl) return;
      const currentSrc = imgEl.currentSrc || imgEl.src || '';
      if (currentSrc.split('?')[0] === ensureProtocol(newUrl).split('?')[0]) return;
      imgEl.removeAttribute('srcset');
      imgEl.src = ensureProtocol(newUrl);
    };

    const updateCardPrice = (card, variant) => {
      const priceEl = card.querySelector('.byo__product-price');
      if (!priceEl || !variant) return;
      const cents = Number(variant.price) || 0;
      priceEl.textContent = formatMoneyCLP(cents);
    };

    const collectSelectedOptions = (card) => {
      const result = {};
      card.querySelectorAll('[data-byo-option-name]').forEach((sel) => {
        result[sel.dataset.byoOptionName] = sel.value;
      });
      return result;
    };

    const addItem = (card) => {
      const variant = resolveVariantForCard(card);
      if (!variant || !variant.available) {
        alert('Este producto/variante no está disponible.');
        return;
      }
      if (state.items.length >= maxItems) {
        alert('Ya alcanzaste el máximo de ' + maxItems + ' artículos.');
        return;
      }
      const lineId = 'line_' + Math.random().toString(36).slice(2, 9);
      state.items.push({
        lineId, cardEl: card,
        variantId: variant.id,
        productId: card.dataset.productId,
        productHandle: card.dataset.productHandle,
        title: card.dataset.productTitle,
        variantTitle: variant.title === 'Default Title' ? '' : variant.title,
        price: Number(variant.price) || Number(card.dataset.productDefaultPrice) || 0,
        image: variantFeaturedImageUrl(variant) || card.dataset.productImage,
        optionSelections: collectSelectedOptions(card),
      });
      card.dataset.byoAdded = 'true';
      render();
    };

    const removeItem = (lineId) => {
      const item = state.items.find((i) => i.lineId === lineId);
      if (item && item.cardEl) {
        const stillUsed = state.items.some((i) => i.lineId !== lineId && i.variantId === item.variantId);
        if (!stillUsed) item.cardEl.dataset.byoAdded = 'false';
      }
      state.items = state.items.filter((i) => i.lineId !== lineId);
      render();
    };

    const currentTier = () => {
      const count = state.items.length;
      let active = null;
      tiers.forEach((t) => { if (count >= Number(t.min_items)) active = t; });
      return active;
    };

    const nextTier = () => {
      const count = state.items.length;
      return tiers.find((t) => count < t.min_items) || null;
    };

    const render = () => {
      const count = state.items.length;
      const subtotal = state.items.reduce((s, i) => s + (Number(i.price) || 0), 0);
      const tier = currentTier();
      const discountPct = tier ? Number(tier.discount_pct) || 0 : 0;
      const discountAmount = Math.max(0, Math.round(subtotal * (discountPct / 100)));
      const total = Math.max(0, subtotal - discountAmount);

      if (countEl) countEl.textContent = count;
      if (countPluralEl) countPluralEl.hidden = count === 1;

      if (cartList) {
        cartList.innerHTML = state.items.map((i) => `
          <li class="byo__cart-item" data-line-id="${i.lineId}">
            <span class="byo__cart-item-image">${i.image ? `<img src="${i.image}" alt="">` : ''}</span>
            <span class="byo__cart-item-info">
              <span class="byo__cart-item-name">${i.title}</span>
              ${i.variantTitle ? `<span class="byo__cart-item-variant">${i.variantTitle}</span>` : ''}
            </span>
            <button type="button" class="byo__cart-item-remove" aria-label="Quitar" data-byo-remove="${i.lineId}">×</button>
          </li>
        `).join('');
        cartList.querySelectorAll('[data-byo-remove]').forEach((btn) => {
          btn.addEventListener('click', () => removeItem(btn.dataset.byoRemove));
        });
      }
      if (cartEmpty) cartEmpty.hidden = count > 0;

      if (subtotalEl) subtotalEl.textContent = formatMoneyCLP(subtotal);
      if (totalEl) totalEl.textContent = formatMoneyCLP(total);
      // Discount row: always visible while there are items in the kit, so user sees the breakdown
      if (discountRow) discountRow.hidden = count === 0;
      if (tier) {
        if (discountLabelEl) discountLabelEl.textContent = `Descuento ${tier.discount_pct}%`;
        if (discountAmountEl) discountAmountEl.textContent = '-' + formatMoneyCLP(discountAmount);
        discountRow.dataset.byoDiscountNoTier = 'false';
      } else {
        const firstTierMin = tiers.length > 0 ? tiers[0].min_items : 3;
        if (discountLabelEl) discountLabelEl.textContent = `Descuento (agrega ${firstTierMin}+ items)`;
        if (discountAmountEl) discountAmountEl.textContent = '-' + formatMoneyCLP(0);
        if (discountRow) discountRow.dataset.byoDiscountNoTier = 'true';
      }

      tierChips.forEach((chip) => {
        const min = Number(chip.dataset.tierMin);
        chip.dataset.tierActive = (tier && tier.min_items === min) ? 'true' : 'false';
      });

      const maxTierItems = tiers.length > 0 ? tiers[tiers.length - 1].min_items : minItems;
      const pct = Math.min(100, (count / maxTierItems) * 100);
      if (progressFill) progressFill.style.width = pct + '%';

      progressTiers.forEach((pt) => {
        const minVal = Number(pt.dataset.progressTierMin);
        pt.dataset.progressTierReached = (count >= minVal) ? 'true' : 'false';
      });

      if (progressMsg) {
        const firstTierMin = tiers.length > 0 ? tiers[0].min_items : null;
        if (count === 0) {
          progressMsg.textContent = `Selecciona al menos ${minItems} artículos para agregar al carrito${firstTierMin ? ` (desde ${firstTierMin} obtienes descuento)` : ''}`;
        } else if (!tier) {
          const next = nextTier();
          const missing = next ? next.min_items - count : 0;
          progressMsg.textContent = `Agrega ${missing} más para llegar a ${next ? next.discount_pct : ''}% off`;
        } else {
          const next = nextTier();
          if (next) {
            const missing = next.min_items - count;
            progressMsg.textContent = `¡${tier.discount_pct}% off activo! Agrega ${missing} más para ${next.discount_pct}% off`;
          } else {
            progressMsg.textContent = `¡Máximo descuento activo: ${tier.discount_pct}% off!`;
          }
        }
      }

      if (ctaBtn) ctaBtn.disabled = count < minItems;

      // Update collapsed-sidebar summary (mobile)
      if (handleCountEl) handleCountEl.textContent = count;
      if (handleTotalEl) handleTotalEl.textContent = formatMoneyCLP(total);
    };

    const addBundleToCart = async () => {
      if (state.items.length < minItems) return;
      ctaBtn.disabled = true;
      const origText = ctaBtn.textContent;
      ctaBtn.textContent = 'Agregando...';
      try {
        const grouped = {};
        state.items.forEach((i) => {
          if (!grouped[i.variantId]) {
            grouped[i.variantId] = { id: i.variantId, quantity: 0, properties: { '_bundle': config.bundle_handle } };
          }
          grouped[i.variantId].quantity += 1;
        });
        const items = Object.values(grouped);

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        await res.json();

        const opened = await refreshAndOpenSlideCart();
        ctaBtn.disabled = false;
        ctaBtn.textContent = origText;
        if (!opened) {
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error(err);
        alert('Hubo un problema agregando el bundle. Intentá de nuevo.');
        ctaBtn.disabled = false;
        ctaBtn.textContent = origText;
      }
    };

    // Wire up product cards
    root.querySelectorAll('[data-byo-product]').forEach((card) => {
      // On selector change → update image
      card.querySelectorAll('[data-byo-option-name]').forEach((sel) => {
        sel.addEventListener('change', () => {
          const v = resolveVariantForCard(card);
          if (v) { updateCardImage(card, v); updateCardPrice(card, v); }
        });
      });

      const addBtn = card.querySelector('[data-byo-add]');
      if (addBtn) addBtn.addEventListener('click', () => addItem(card));
    });

    if (ctaBtn) ctaBtn.addEventListener('click', addBundleToCart);
    if (sidebarToggle && sidebarEl) {
      sidebarToggle.addEventListener('click', () => {
        sidebarEl.classList.toggle('is-expanded');
      });
    }
    render();
  });
})();
